import { observable, action, computed, makeObservable, when } from "mobx";
import { Observer } from "mobx-react";
// import widgetConfigs from "configs/widgetConfig";
import RequestHandler from "../libs/RequestHandler/RequestHandler";
import RequestStore from "../libs/RequestHandler/RequestStore";
import ParameterStore from "../libs/RequestHandler/Debug/ParameterStore";
import * as LayerUtils from "../components/mapComponent/src/utils/Layer";
import LayerStore from "@giscon/utils.layer-store";
import GeometryPicker from "../libs/GeometryPicker";
import ErrorBoundary from "../../../components/ErrorBoundary";
import isMobile from "ismobilejs";
const isMobileDeviceConst = isMobile(window.navigator).any;
class UiStoreSingleArea {
  widgets = {};
  activeWidgetId = "";
  icons = {};
  widgetConfigs = {};
  order = [];
  width = 360;
  height = 100;
  maxWidth = document.body.offsetWidth - 40;
  minWidth = 10;
  maxHeight = 100000; //document.body.offsetHeight - 100;
  minHeight = 10;
  moving = false;
  resizing = false;
  moveListener = null;
  resizeListener = null;
  get activeWidget() {
    return this.widgets[this.activeWidgetId];
  }
  get widgetAreaWidth() {
    if (this.width >= this.minWidth) {
      if (this.width <= this.maxWidth) {
        return this.width;
      }
      return this.maxWidth;
    }
    return this.minWidth;
  }
  get widgetAreaHeight() {
    if (this.height >= this.minHeight) {
      if (this.height <= this.maxHeight) {
        return this.height;
      }
      return this.maxHeight;
    }
    return this.minHeight;
  }

  getWidgetPosition(position) {
    if (this[position] !== undefined) {
      return Math.max(this[position], 0);
    }
    return undefined;
  }
  get widgetTop() {
    return this.getWidgetPosition("top");
  }
  get widgetBottom() {
    return this.getWidgetPosition("bottom");
  }
  get widgetLeft() {
    return this.getWidgetPosition("left");
  }
  get widgetRight() {
    return this.getWidgetPosition("right");
  }

  constructor({
    uiStore,
    order,
    rootStore,
    direction = "right",
    positionOptions = {},
    buttonPosition = "top",
    widgetConfigs,
    width,
  }) {
    this.uiStore = uiStore;
    this.rootStore = rootStore;
    this.direction = direction;
    this.order = order;
    if (width) {
      this.width = width;
    }
    this.buttonPosition = buttonPosition
      ? buttonPosition
      : direction === "onMap"
      ? "top"
      : undefined;
    const {
      left,
      right,
      top,
      bottom,
      minHeight = 10,
      maxHeight = 1000000,
      minWidth = 10,
      maxWidth = 1000000,
      closeable = true,
      moveable = true,
      resizeDirections = ["bottom-right"], // "full", // "height", "width", "none",
      initActive = "",
    } = positionOptions;
    this.activeWidgetId = initActive;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    if (left === undefined && right === undefined) this.right = 0;
    if (bottom === undefined && top === undefined) this.top = 0;
    this.minHeight = Math.max(this.minHeight, minHeight);
    this.maxHeight = Math.min(this.maxHeight, maxHeight);
    this.minWidth = Math.max(this.minWidth, minWidth);
    this.maxWidth = Math.min(this.maxWidth, maxWidth);
    this.closeable = closeable;
    this.moveable = moveable;
    this.resizeDirections = resizeDirections;

    makeObservable(this, {
      direction: observable,
      widgets: observable,
      order: observable,
      buttonPosition: observable,
      moving: observable,
      resizing: observable,
      maxWidth: observable,
      minWidth: observable,
      minHeight: observable,
      maxHeight: observable,
      widgetAreaWidth: computed,
      widgetAreaHeight: computed,
      widgetTop: computed,
      widgetBottom: computed,
      widgetLeft: computed,
      widgetRight: computed,
      width: observable,
      height: observable,
      left: observable,
      right: observable,
      bottom: observable,
      closeable: observable,
      moveable: observable,
      resizeDirections: observable,
      setWidgetAreaWidth: action,
      setWidgetAreaHeight: action,
      activeWidget: computed,
      activeWidgetId: observable,
      openWidget: action,
      closeWidget: action,
      setMoving: action,
      setResizing: action,
      isWidgetOpen: computed,
      moveListener: observable.ref,
      resizeListener: observable.ref,
      setResizeListener: action,
      setMoveListener: action,
      setDirectionPosition: action,
    });
    this.widgets = {};
    this.initWidgets(widgetConfigs);
  }

  getWidget = (widgetConfig, id) => {
    // const geo = {
    //   EditToolbar: EditToolbar,
    //   LayerStore: LayerStore,
    //   map: LayerStore.map,
    //   mapStore: this.rootStore.mapStore,
    //   LayerUtils,
    // };
    const {
      Widget,
      props = {},
      isClassComp = false,
      observableProps = {},
      init = () => {},
      buildProps = {},
      manipulateProps = (obj) => obj,
      fetchedProps = {},
    } = widgetConfig;
    // makeAutoObservable(props);

    const additionalProps = init();
    if (typeof additionalProps == "object") {
      Object.keys(additionalProps).forEach(
        (key) => (props[key] = additionalProps[key])
      );
    }
    Object.keys(buildProps).forEach((key) => (props[key] = buildProps[key]()));

    const widget = () => {
      return (
        <Observer>
          {() => {
            const evauluateArray = (arr) => {
              const [target, attrsString, def] = arr;
              let targetStore = target;
              if (typeof targetStore == "string")
                targetStore = this.rootStore[targetStore];
              if (targetStore) {
                const attrs = attrsString.split(".");
                const val = attrs.reduce(
                  (acc, cur) =>
                    acc && typeof acc == "object" ? acc[cur] : undefined,
                  targetStore
                );
                if (val !== undefined) return val;
                return def;
              }
              return def;
            };
            const newObsProps = { ...props };
            try {
              Object.keys(observableProps).map(
                (key) =>
                  (newObsProps[key] = evauluateArray(observableProps[key]))
              );
            } catch (e) {
              console.error(e);
            }
            return (
              <ErrorBoundary>
                <Widget
                  map={this.rootStore.mapStore.map}
                  mapStore={this.rootStore.mapStore}
                  LayerStore={LayerStore}
                  RequestStore={RequestStore}
                  // geo={geo}
                  tokenId={this.tokenId}
                  role={LayerStore.role}
                  selection={LayerStore.selection}
                  view={LayerStore.view}
                  opened={this.activeWidgetId === id}
                  LayerUtils={LayerUtils}
                  CommunicationStore={this.rootStore.communicationStore}
                  // Controller={Controller}
                  // EditToolbar={EditToolbar}
                  GeometryPicker={GeometryPicker}
                  // nls={nls}
                  {...manipulateProps(newObsProps)}
                  {...fetchedProps}
                />
              </ErrorBoundary>
            );
          }}
        </Observer>
      );
    };
    if (!isClassComp) {
      return widget();
    } else {
      return widget;
    }
  };
  initWidgets = (widgetConfigs) => {
    if (!this.order) this.order = widgetConfigs[this.direction];
    this.tokenId = widgetConfigs.tokenId;
    this.order.forEach((id) => {
      const { icon } = widgetConfigs.widgets[id];
      this.widgets[id] = this.getWidget(widgetConfigs.widgets[id], id);
      this.icons[id] = icon;
      this.widgetConfigs[id] = widgetConfigs.widgets[id];
    });
  };
  get isWidgetOpen() {
    return this.activeWidgetId !== "";
  }

  openWidget = (widgetId) => {
    this.activeWidgetId = widgetId;
    if (!(this.direction in { onMap: 1, overlay: 1 })) {
      this.uiStore.activeDirection = this.direction;
    }
  };

  closeWidget = () => {
    this.activeWidgetId = "";
  };

  setMoving = (moving) => {
    this.moving = moving;
  };

  setResizing = (resizing) => {
    this.resizing = resizing;
  };

  setWidgetAreaWidth = (width) => {
    this.width = width;
  };
  setWidgetAreaHeight = (height) => {
    this.height = height;
  };

  setMoveListener = (listener) => {
    this.moveListener = listener;
  };

  setResizeListener = (listener) => {
    this.resizeListener = listener;
  };

  setLeft = (pos) => {
    this.setDirectionPosition("left", pos);
  };
  setRight = (pos) => {
    this.setDirectionPosition("right", pos);
  };
  setTop = (pos) => {
    this.setDirectionPosition("top", pos);
  };
  setBottom = (pos) => {
    this.setDirectionPosition("bottom", pos);
  };
  setDirectionPosition(direction, position) {
    if (this[direction] !== undefined) {
      this[direction] = position;
    }
  }
  openIfExist = (id) => {
    if (!!this.widgets[id]) {
      this.openWidget(id);
      return true;
    }
    return false;
  };
  closeIfExistAndOpen = (id) => {
    if (!!this.widgets[id] && this.activeWidgetId === id) {
      this.closeWidget();
    }
  };
}

class BoundingBoxStore {
  height = window.innerHeight;
  width = window.innerWidth;
  customMobileFunction = undefined;

  isMobileDevice = isMobileDeviceConst;
  get mobile() {
    // this.height !== undefined /*just to also observe height here*/
    const mobile = this.width < 750;
    if (this.customMobileFunction) {
      return this.customMobileFunction(this.width, this.height);
    }
    return mobile;
  }
  setWidth(value) {
    this.width = value;
  }
  setHeight(value) {
    this.height = value;
  }
  constructor() {
    makeObservable(this, {
      customMobileFunction: observable.ref,
      height: observable.ref,
      width: observable.ref,
      setHeight: action,
      setWidth: action,
      mobile: computed,
    });
    const timeouts = [];
    const handler = () => {
      // window was resized
      while (timeouts.length) {
        clearTimeout(timeouts.pop());
      }
      // buffer 200ms to not rerender too often
      const timeout = setTimeout(() => {
        try {
          timeouts.splice(timeouts.indexOf(timeout), 1);
        } catch (e) {}
        this.setHeight(window.innerHeight);
        this.setWidth(window.innerWidth);
        // console.log(`Resize to ${window.innerWidth} x ${window.innerHeight}`);
      }, 200);
      timeouts.push(timeout);
    };
    window.addEventListener("resize", handler);
  }
}

const BBStore = new BoundingBoxStore();
export { BBStore };
class UiStore {
  subUiStores = {};
  activeDirection = "";
  BBStore = BBStore;
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.isReady = false;
    this.relativeToMap = true;
    this.bottomBarHeight = 0;
    // this.BBStore = BBStore;
    makeObservable(this, {
      isReady: observable,
      subUiStores: observable,
      relativeToMap: observable,
      bottomBarHeight: observable,
      mapLeft: computed,
      mapRight: computed,
      setBottomBarHeight: action,
      activeDirection: observable.ref,
      mobile: computed,
    });
    // this.initRequestHandler(requestsConfig);
  }
  get mobile() {
    return this.BBStore.mobile;
  }
  initialize({ widgetConfigs, requestsConfig }) {
    const { relativeToMap = true } = widgetConfigs;
    this.relativeToMap = relativeToMap;
    this.initRequestHandler(requestsConfig);
    when(
      () => this.requiredLoaded(widgetConfigs),
      () => this.initWidgets(widgetConfigs)
    );
  }

  requiredLoaded(widgetConfigs) {
    if (widgetConfigs.updateConfigsKey !== undefined) {
      const { state } = RequestStore.requests[widgetConfigs.updateConfigsKey];
      if (state === "loading") return false;
    }
    if (LayerStore.layerManager) return true;
    return false;
  }

  updateWidgetConfigsWithFetchedJSON(preWidgetConfigs) {
    if (preWidgetConfigs.updateConfigsKey !== undefined) {
      const { state, value } =
        RequestStore.requests[preWidgetConfigs.updateConfigsKey];
      if (state === "error") return;
      if (state === "success") {
        if (value === undefined) return;
        const {
          widgetConfig = {},
          configModus = "rewrite",
          deleteString = "undefined",
          arrayMerge = "rewrite",
          arraySkipIndex = "skip",
          arrayDeepMerge = false,
        } = value;

        Object.keys(widgetConfig).forEach((widgetKey) => {
          if (widgetConfig[widgetKey] === deleteString) {
            if (preWidgetConfigs.widgets[widgetKey] !== undefined) {
              preWidgetConfigs.widgets[widgetKey].props = {};
            }
            return;
          }
          if (preWidgetConfigs.widgets[widgetKey].props === undefined) {
            preWidgetConfigs.widgets[widgetKey].props = {};
          }
          this.updateSingleWidgetConfig({
            targetProps: preWidgetConfigs.widgets[widgetKey].props,
            updateProps: widgetConfig[widgetKey],
            configModus,
            deleteString,
            arrayMerge: arrayMerge,
            arraySkipIndex: arraySkipIndex,
            arrayDeepMerge: arrayDeepMerge,
          });
          // preWidgetConfigs.widgets[widgetKey].fetchedProps =
          //   widgetConfig[widgetKey];
        });
      }
    }
  }

  updateSingleWidgetConfig({
    targetProps,
    updateProps,
    configModus = "rewrite",
    deleteString = "undefined",
    arrayMerge = "rewrite",
    arraySkipIndex = "skip",
    arrayDeepMerge = false,
  }) {
    let effectiveConfigModus = configModus;
    if (targetProps.configModus !== undefined) {
      effectiveConfigModus = targetProps.configModus;
    }
    if (effectiveConfigModus === "rewrite") {
      // dann als {...fetchedProps} in der einbindung
      targetProps.fetchedProps = updateProps;
    } else if (effectiveConfigModus === "merge") {
      this.merge({
        target: targetProps,
        update: updateProps,
        modus: effectiveConfigModus,
        deleteString: deleteString,
        arrayMerge: arrayMerge,
        arraySkipIndex: arraySkipIndex,
        arrayDeepMerge: arrayDeepMerge,
      });
    }
  }

  rewrite({ target, update, modus, deleteString }) {
    let effModus = modus;
    if (target.configModus !== undefined) effModus = target.configModus;
    if (effModus === "merge") {
      this.merge({ target, update, effModus, deleteString });
    } else {
      Object.keys(update).forEach((key) => (target[key] = update[key]));
    }
  }
  merge({
    target,
    update,
    modus,
    deleteString,
    arrayMerge = "rewrite",
    arraySkipIndex = "skip",
    arrayDeepMerge = false,
  }) {
    let effModus = modus;
    arrayMerge = target.arrayMerge || arrayMerge;
    arraySkipIndex = target.arraySkipIndex || arraySkipIndex;
    arrayDeepMerge = target.arrayDeepMerge || arrayDeepMerge;
    if (target.configModus !== undefined) effModus = target.configModus;
    if (effModus === "rewrite") {
      this.rewrite({ target, update, effModus, deleteString });
    } else {
      Object.keys(update).forEach((key) => {
        if (typeof update[key] == "object") {
          if (Array.isArray(update[key])) {
            if (arrayMerge === "rewrite") {
              target[key] = update[key];
              return;
            }
            if (!Array.isArray(target[key])) target[key] = [];
            if (arrayMerge === "append") {
              target[key].concat(update[key]);
              return;
            }
            if (arrayMerge === "merge") {
              update[key].forEach((up, i) => {
                if (up === arraySkipIndex) return;
                if (i >= target[key].length) {
                  target[key].push(up);
                  return;
                }
                if (
                  typeof up === "object" &&
                  typeof target[key][i] === "object" &&
                  arrayDeepMerge
                ) {
                  this.merge({
                    target: target[key][i],
                    update: up,
                    modus,
                    deleteString,
                    arrayMerge,
                    arraySkipIndex,
                    arrayDeepMerge,
                  });
                  return;
                }
                target[key][i] = up;
              });
            }
            //idk?
            // rewrite
            //
            // append
          } else {
            target[key] = target[key] || {};
            this.merge({
              target: target[key],
              update: update[key],
              modus: effModus,
              deleteString,
              arrayMerge,
              arraySkipIndex,
              arrayDeepMerge,
            });
          }
        } else if (update[key] === deleteString) {
          target[key] = undefined;
        } else {
          target[key] = update[key];
        }
      });
    }
  }

  getMapHorizontalDirection(direction) {
    if (this.subUiStores[direction]) {
      return this.subUiStores[direction].isWidgetOpen
        ? this.subUiStores[direction].widgetAreaWidth
        : 0;
    }
    return 0;
  }
  get mapLeft() {
    return this.getMapHorizontalDirection("left");
  }
  get mapRight() {
    return this.getMapHorizontalDirection("right");
  }

  forEachSubstore = (fun) => {
    Object.keys(this.subUiStores).forEach((subKey) => {
      Array.isArray(this.subUiStores[subKey])
        ? this.subUiStores[subKey].forEach((store) => fun(store))
        : fun(this.subUiStores[subKey]);
    });
  };

  openWidget = (id) => {
    this.forEachSubstore((store) => store.openIfExist(id));
  };

  closeWidget = (id) => {
    this.forEachSubstore((store) => store.closeIfExistAndOpen(id));
  };

  initRequestHandler = (requestsConfig) => {
    requestsConfig.store = ParameterStore;
    RequestStore.setParameterStore(ParameterStore);
    this.RequestHandler = new RequestHandler(requestsConfig);
    this.rootStore.RequestStore = RequestStore;
  };

  initWidgets = (widgetConfigs) => {
    console.error("initWidgets", widgetConfigs);
    this.updateWidgetConfigsWithFetchedJSON(widgetConfigs);
    this.rootStore.communicationStore.openWidget = (id) => this.openWidget(id);
    this.rootStore.communicationStore.closeWidget = (id) =>
      this.closeWidget(id);
    this.subUiStores["right"] = new UiStoreSingleArea({
      uiStore: this,
      direction: "right",
      width: 460,
      rootStore: this.rootStore,
      widgetConfigs: widgetConfigs,
      positionOptions: widgetConfigs.rightOptions,
    });
    this.subUiStores["left"] = new UiStoreSingleArea({
      uiStore: this,
      direction: "left",
      rootStore: this.rootStore,
      widgetConfigs: widgetConfigs,
      positionOptions: widgetConfigs.leftOptions,
    });
    this.subUiStores["onMap"] = widgetConfigs["onMap"].map(
      (conf) =>
        new UiStoreSingleArea({
          uiStore: this,
          direction: "onMap",
          rootStore: this.rootStore,
          order: conf.order,
          positionOptions: conf.positionOptions,
          buttonPosition: conf.buttonPosition,
          widgetConfigs: widgetConfigs,
        })
    );
    this.subUiStores["overlay"] = new UiStoreSingleArea({
      uiStore: this,
      direction: "overlay",
      rootStore: this.rootStore,
      widgetConfigs: widgetConfigs,
    });
    this.isReady = true;
  };

  setBottomBarHeight = (height) => {
    this.bottomBarHeight = height;
  };
}

export default UiStore;
